module.exports = __webpack_public_path__ + "assets/static/media/splash_screen_2.683d7bef.png";